<template>
  <d-container fluid class="main-content-container px-4" v-if="logIn">
    <!-- Main Navbar -->
    <main-navbar />
    <!-- User Info Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-6 mb-sm-0">
        <span class="text-uppercase page-subtitle">Хяналтын самбар</span>
        <h3 class="page-title">Хэрэглэгчийн мэдээлэл</h3>
      </d-col>
    </d-row>

    <!-- Small Stats Blocks -->
    <d-row>
      <b-col xl="12" md="12" sm="12">
        <stats-card
          type="gradient-info"
          contractIcon="fa fa-file"
          phoneIcon="fa fa-phone"
          packageIcon="fa fa-tv"
          billIcon="fa fa-clock"
          emailIcon="fa fa-envelope"
          passIcon="fa fa-key"
          class="mb-4"
          :contractId="detail.id"
          :phoneNumbers="userPhone"
          :packageType="detail.productName"
          billDate="2021-03-01"
          :email="detail.email"
          :selected="selectedOption"
        >
        </stats-card>
      </b-col>
    </d-row>

    <!-- User Useage Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle"
          >Хамарагдах хугацаа: 2021.03.01 - 2021.03.29</span
        >
        <h3 class="page-title">Хэрэглээний мэдээлэл</h3>
      </d-col>
    </d-row>

    <!-- Small Stats Blocks -->
    <d-row>
      <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4">
        <user-usage
          :id="`small-stats-${idx}`"
          variation="1"
          :icon="stats.icon"
          :chart-data="stats.datasets"
          :label="stats.label"
          :value="stats.value"
          :usedData="stats.usedData"
          :remainData="stats.remainData"
          :processBar="stats.process"
          :btnName="stats.btnName"
          :parentBoolean="stats.open"
          :increase="stats.increase"
          :decrease="stats.decrease"
          :qpayStatus="golomtStatus"
        />
      </d-col>
    </d-row>

    <d-row>
      <!-- Users by Device (lite) -->
      <d-col lg="4" md="6" sm="12" class="mb-4">
        <userPaymentHistory />
      </d-col>
      <!-- Users Overview -->
      <d-col lg="8" md="6" sm="12" class="mb-4">
        <d-card>
          <d-tabs card>
            <d-tab title="Нэхэмжлэхийн жагсаалт" active>
              <userInvoices />
            </d-tab>
            <!--  <d-tab title="Ярианы хэрэглээний график" hidden>
              <bo-users-overview />
            </d-tab>
            <d-tab title="Дуудлагын жагсаалт" hidden>
              <user-table />
            </d-tab> -->
          </d-tabs>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import MainNavbar from "@/components/layout/MainNavbar/MainNavbar.vue";
// Components
import StatsCard from "@/components/card/StatsCard";
import UserUsage from "@/components/common/UserUsage.vue";
import UserInvoices from "@/components/common/UserInvoices.vue";
//import UserGraphic from "@/components/common/UserGraphic.vue";
//import UserTable from "@/components/common/UserTable.vue";
import UserPaymentHistory from "@/components/common/UserPaymentHistory.vue";
// Axios
import axios from "axios";


export default {
 async created() {
    //check link with params or not
    if (this.$router.history.current.query.id != null) {
      const tranconfig = {
        method: "post",
        url:
          "https://mongolsat.mn/isat/contract/invoice/check?id=" +
          this.$router.history.current.query.id +
          "",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.userToken,
        },
      };
      //transaction check by id
   await axios(tranconfig).then(
        (response) => {
          if (response.data.code == 0 && response.data.object == true) {
            this.golomtStatus = "success";
            this.openModal = true;
            var configData = {
              method: "post",
              url: "https://mongolsat.mn/isat/contract/data",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPayment = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/payments?page=1",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPhone = {
              method: "post",
              url: "https://www.mongolsat.mn/isat/contract/phones",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configInvoice = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/invoices?page=1&rows=10",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };

            const requestOne = axios(configData);
            const requestTwo = axios(configPayment);
            const requestThirth = axios(configPhone);
            const requestFourth = axios(configInvoice);

            axios
              .all([requestOne, requestTwo, requestThirth, requestFourth])
              .then(
                axios.spread((...responses) => {
                  const responseOne = responses[0];
                  const responseTwo = responses[1];
                  const responseThirth = responses[2];
                  const responseFourth = responses[3];

                  if (
                    responseOne.data.code == 0 &&
                    responseOne.data.object != null
                  ) {
                    this.$store.dispatch("retrieveAddData", {
                      addData: responseOne.data.object.topupQuota,
                    });
                    this.$store.dispatch("retrieveRemainData", {
                      remainData: responseOne.data.object.remainingQuota,
                    });
                  }
                  if (responseTwo.data != null && responseTwo.data.length > 0) {
                    this.$store.dispatch("retrievePayments", {
                      payments: responseTwo.data,
                    });
                  }
                  if (
                    responseThirth.data.code == 0 &&
                    responseThirth.data.object != null
                  ) {
                    var tmpPhoneList = [];
                    var i = 0;

                    for (i = 0; i < responseThirth.data.object.length; i++) {
                      var data = {};
                      (data.id = i),
                        (data.name = responseThirth.data.object[i].name),
                        (data.phone = responseThirth.data.object[i].phone),
                        (data.balance =
                          responseThirth.data.object[i].balance < 1
                            ? 0
                            : responseThirth.data.object[i].balance),
                        tmpPhoneList.push(data);
                    }
                    this.$store.dispatch("retrievePhoneData", {
                      phoneData: tmpPhoneList,
                    });

                    this.$store.dispatch("retrieveSelected", {
                      selected: tmpPhoneList[this.selectedOption.id],
                    });

                    this.$store.dispatch("retrieveBalance", {
                      balance:
                        responseThirth.data.object[this.selectedOption.id]
                          .balance < 1
                          ? 0
                          : responseThirth.data.object[this.selectedOption.id]
                              .balance,
                    });
                  }
                  if (
                    responseFourth.data.records != null &&
                    responseFourth.data.records.length > 0
                  ) {
                    this.$store.dispatch("retrieveInvoice", {
                           invoice: responseFourth.data.records
                    });              
                  }
                }),
                (error) => {
                  console.log(error);
                }
              );
          } else {
            this.golomtStatus = "fail";
            this.openModal = true;
          } 
        },
        (error) => {
          console.log(error);
        }
      );  
      
    }
  },
  components: {
    MainNavbar,
    StatsCard,
    UserUsage,
   // UserTable,
    UserInvoices,
   // boUsersOverview: UserGraphic,
    UserPaymentHistory
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null,
      },
      openModal: false,
      golomtStatus:""
    };
  },
  computed: {
    smallStats() {
      return [
        {
          icon: "fa fa-database fa-lg",
          label: "Үндсэн дата үлдэгдэл",
          value: this.remainUnit == null ? 0 + " GB" : this.remainUnit + " GB",
          remainData: this.addtionalData == 0 && this.usedData > 0 ? (this.remainUnit - this.usedData) + " GB": this.remainUnit + " GB", 
          usedData: this.addtionalData == 0 && this.usedData > 0 ? this.usedData + " GB": 0 + " GB", 
          increase: true,
          process: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(0, 184, 216, 0.1)",
              borderColor: "rgb(0, 184, 216)",
              data: [1, 2, 1, 3, 5, 4, 7],
            },
          ],
        },
        {
          icon: "fa fa-plus-square fa-lg",
          label: "Нэмэлт дата",
          value: this.addtionalData != null ? this.addtionalData + " GB" : 0 + " GB",
          remainData: this.addtionalData > 0 && this.usedData > 0 ? (this.addtionalData - this.usedData) + " GB": 0 + " GB", 
          usedData: this.addtionalData > 0 && this.usedData > 0 ?  this.usedData + " GB": 0 + " GB", 
          btnName: "Дата",
          increase: true,
          process: true,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(23,198,113,0.1)",
              borderColor: "rgb(23,198,113)",
              data: [1, 2, 3, 3, 3, 4, 4],
            },
          ],
          open: this.openModal,
        },
        {
          icon: "fa fa-phone-square fa-lg",
          label: "Ярианы үлдэгдэл нэгж",
          value: this.balance < 1 ? 0 : this.balance,
          btnName: null,
          increase: false,
          decrease: true,
          process: false,
          labels: ["Label", "Label", "Label", "Label", "Label", "Label"],
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,180,0,0.1)",
              borderColor: "rgb(255,180,0)",
              data: [2, 3, 3, 3, 4, 3, 3],
            },
          ],
        },
      ];
    },
    logIn() {
      return this.$store.getters.loggedIn;
    },
    detail(){
      return this.$store.getters.userDetail;
    },
    userPhone(){
      return this.$store.getters.userPhoneData;
    },
    remainUnit(){
      const const_term = 1024;
      return (this.$store.getters.userRemainingData / const_term ** 2).toFixed(1);
    },
    addtionalData(){
      const const_term = 1024;
      return (this.$store.getters.userAdditionData / const_term ** 2).toFixed(1);
    },
    usedData(){
      const const_term = 1024;
      return ( this.$store.getters.userUsedData / const_term ** 2).toFixed(1);
    },
    balance(){
      return this.$store.getters.userBalance > 0 ?  (this.$store.getters.userBalance / 1).toFixed(0) : this.$store.getters.userBalance;
    },
    selectedOption(){
      return this.$store.getters.selected;
    },
  },
};
</script>

